// v2 of the view-members family. Uses NEW Triyo.API PascalCase data shapes (`UserId`,
// `User.Name`, `Group.Members`). Originally still pulled in the legacy MVC `<PlusIconPanel>`
// for member editing despite the "-New" filename; that chain was killed in TAD-5150 — this
// component now uses `<PlusIconPanelNew>`, which calls the NEW `EditProjectMembers`
// endpoint and self-fetches its users/groups list via the NEW Triyo.API
// (`GetAllUsersNew` / `GetAllGroupsAPI`).
//
// This component, `view-members.jsx` (v1), and `view-members-projects.jsx` (v3) are three
// generations of the same "show member icons + popover + optional Plus button" concept.
// Consolidating them into a single component is a separate architectural cleanup,
// deliberately out of scope for the Triyo.MVC removal effort.
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import MemberIconNew from "../member-icon-new/member-icon-new";
import MemberDropdownNew from "../member-dropdown-new/member-dropdown-new";
import PlusIconPanel from "../plus-icon/Plus-Icon-Panel-New";
import PlusIcon from "../plus-icon/Plus-Icon";
import "./view-members-new.scss";

const ViewMembersPanelNew = ({
  members,
  groups,
  taskCreator,
  UserID,
  taskType,
  projects,
  onEdit,
  isGroup,
  textChange = false,
  memberAddDisabled,
  isHidden = false,
  isMultiOwner = false
}) => {
  const membersArray = members ?? [];
  const memberLength = membersArray.length > 0 ? membersArray.length : 0;

  const [user, setUser] = useState({}); //stores the owner object
  const [extraMembers, setExtraMembers] = useState(memberLength - 3); //amount of extraMembers
  const [ownerShown, setOwnerShown] = useState(false);

  //for projects implementation
  const [plusPosition, setPlusPosition] = useState(0);
  const [nameClass, setNameClass] = useState("");
  const [showPlusPanel, setShowPlusPanel] = useState(false);
  const [membersCount, setMembersCount] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMembersTooltipVisible, setIsMembersTooltipVisible] = useState(false)
  const [ownerGroup , setOwnerGroup] = useState(null);

  // Default user
  const [MembersShown, setMembersShown] = useState([

    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      // userNameFull: "Z Z",
      User:{Name:"Z Z"}, //-- Change all the names here
      view: false,
    },
  ]);

  const [MembersOnPanel, setMembersOnPanel] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      // userNameFull: "Z Z",
      User:{Name:"Z Z"}, //--
      view: false,
    },
  ]);
  
  //array that stores the classNames of all the icon positions
  const [position, setNewPosition] = useState([
    "first-icon",
    "second-icon",
    "third-icon",
    "fourth-icon",
    "fifth-icon"
  ]);

  const setGroups = () => {
    let temp = groups?.filter((group) => {
      return group.IsOwner;
    });
    if(temp?.length > 0){
      setOwnerGroup(temp[0]);
    }
  }

  const FindClassName = (length) => {
    if(length<=3){
      return "show-member-panel"
    }
    else if(projects){
      return "show-member-panel-projects"
    }
    else if(length === 4){
      return "show-member-panel-tasks-1"
    }
    else{
      return "show-member-panel-tasks"
    }

  }

  const initialFunction = () => {
    //FINDS OWNER, SORTS MEMBERS IN ALPHABETICAL ORDER WITH OWNER AS FIRST ELEMENT
    const newUser = membersArray.find((element) => {
      if (element?.UserId) {
        return element.UserId === UserID;
      } else {
        return element.Id === UserID;
      }
    });
    let newMembersList = [];
    let newMembersShown = [];
    let count = 0;

    if (newUser) {
      setUser(newUser);
      newMembersList = membersArray.filter((member) => {
        if (member.UserId) {
          return member?.UserId !== UserID;
        } else {
          return member.Id !== UserID;
        }
      });
      if (groups && groups.length > 0) {
        let groupList = groups?.filter(x => !x.IsOwner).map((element) => { return { User: element, IsGroup: true } });
        newMembersList = newMembersList.concat(groupList);
      }
      setOwnerShown(true);
    } else {
      newMembersList = memberLength > 0 ? membersArray : [];
      setOwnerShown(false);
    }
    newMembersShown = newMembersList.sort(function compare(a, b) {
      let name1 = a.Name ? a.Name.split(" ") : a.User.Name.split(" ");
      let name2 = b.Name ? b.Name.split(" ") : b.User.Name.split(" ");
      if (name1[0] < name2[0]) return -1;
      if (name1[0] > name2[0]) return 1;
      if (name1[0] === name2[0]) {
        if (name1[1] < name2[1]) return -1;
        if (name1[1] > name2[1]) return 1;
      }
    });
    if (newUser) {
      newMembersShown.unshift(newUser);
    }
    if (projects) {
      setNameClass("-projects");
      //setMembersLength based off of length of MembersShown
      if (newMembersShown.length >= 4) {
        setPlusPosition(4);
      } else {
        setPlusPosition(newMembersShown.length);
      }
      setMembersShown(newMembersShown);

      //ADDING THE GROUP MEMBERS TO BE SHOWN ON THE MEMBERS PANEL
      let updatedMembersShown = [];
      //THIS WILL ADD GROUP MEMBERS TO THE LIST IN VIEW MEMBERS PANEL, BUT NOT IN THE ICONS
      for (let i = 0; i < newMembersShown.length; i++) {
        if ((typeof(newMembersShown[i]?.Group?.Members) !== 'undefined') && (newMembersShown[i]?.Group?.Members !== null) ){

          count += newMembersShown[i]?.Group?.Members?.length;

        } else {count++}
      
       updatedMembersShown.push(newMembersShown[i])
      
      }
      setMembersOnPanel(updatedMembersShown)
      setMembersCount(count);
    } else {

      setMembersOnPanel(newMembersShown);
      setMembersShown(newMembersShown);
    }
  };

  const closePlusPanel = () => {
    setShowPlusPanel(false);
  };  
  
  const popperConfig = {
    placement:"bottom-end",
    strategy: "fixed"
  }

  useEffect(() => {
    initialFunction();
    setExtraMembers(membersArray.length - 3);
  }, [members]);

  useEffect(() => {
    setGroups();
  }, [groups]);

  return (
    <div>
      <Dropdown drop={"down"} className="removeArrow" onMouseLeave={() => setShowDropdown(false)}
      onMouseOver={() => setShowDropdown(true)} 
      onClick={(e) => 
        e.nativeEvent.stopImmediatePropagation()
      }
      >
        <Dropdown.Toggle
          as={"div"}
          className={`member-dropdown-toggle${nameClass}`}
          onClick={(e) => 
            e.nativeEvent.stopImmediatePropagation()
          }
        >
          {
             <div>
               {ownerGroup &&
                    <div className={`first-icon`}>
                        {
                          <MemberIconNew member={ownerGroup} type={"user"} isGroup={true}></MemberIconNew>
                        }
                  </div>
                }
                 {ownerGroup && !ownerShown &&
                    <div className={`second-icon`}>
                        {
                           <MemberIconNew
                           member={taskCreator}
                           type={"creator"}
                           isGroup={true}
                           ></MemberIconNew>
                        }
                  </div>
                }
             {
               MembersShown &&
                 MembersShown.slice(0, 4).map((entry, index) => (
                   <div key={index} className={ownerGroup ? !ownerShown ? `ownerGroup ${position[index+2]}`:`ownerGroup ${position[index+1]}` :`${position[index]}`}>
                     {index === 0 && ownerShown && ownerGroup == null? (
                       <MemberIconNew isGroupIcon={entry?.IsGroup} member={entry} type={"user"}></MemberIconNew>
                     ) : index === 3 && extraMembers > 0 ? (
                       <MemberIconNew
                         member={entry}
                         isGroupIcon={entry?.IsGroup}
                         extraMembers={extraMembers}
                         type={"extra"}
                       ></MemberIconNew>
                     ) : (index === 0 && ownerShown && ownerGroup)?
                     <div className="creatorMemberContainer">
                        <MemberIconNew
                          isGroupIcon={entry?.IsGroup}
                          member={entry}
                          type={"creator"}
                          ></MemberIconNew>
                     </div>
                     :(
                       <MemberIconNew
                       isGroupIcon={entry?.IsGroup}
                         member={entry}
                         type={"default"}
                       ></MemberIconNew>
                     )}
                   </div>
                 ))
             }
            </div>
          }
        </Dropdown.Toggle>
        
        <Dropdown.Menu
          popperConfig={popperConfig}
          show={showDropdown}
          style={{ 'width': `${projects? '320px' : '272px'}` }}
          className={FindClassName(memberLength)}
          drop-dropup-auto="false"
        >
          <div className={"member-dropdown-row-header"}>
            <div className={"member-dropdown-title-text"}>
              {
                textChange ? "Actionable by" : "View Members/Groups" 
              }             
            </div>
          </div>
          <Dropdown.Divider style={{ 'width': `${projects? '320px' : '272px'}` }} />
          <div className={"member-dropdown-body-wrapper"}>
            {ownerGroup && (
              <div >
              <MemberDropdownNew
                member={ownerGroup}
                taskType={taskType}
                type={"user"}
                filter={false}
                toggleRow={() => {}}
                selectedMembers={[]}
                projects={projects}
                isGroupOwner = {true}
                isMultiOwner={isMultiOwner}
              />
            </div>
            )}
            {ownerGroup && !ownerShown && (
              <div>
              <MemberDropdownNew
                member={taskCreator}
                taskType={taskType}
                type={"creator"}
                filter={false}
                toggleRow={() => {}}
                selectedMembers={[]}
                projects={projects}
                isGroupOwner = {true}
                isMultiOwner={isMultiOwner}
              />
            </div>
            )}
              {
                MembersOnPanel?.map((entry, index) => (
                  <div key={`${index}-${index}`}>
                    {ownerGroup && index !== 0 && (
                      <Dropdown.Divider
                        style={{ 'width': `${projects ? '290px' : '240px'}`, 'marginLeft': '15px', 'border-bottom': '1px solid #8A8886' }}
                      />
                    )}
                    <MemberDropdownNew
                      member={isGroup ? { ...entry, groupID: null } : entry}
                      taskType={taskType}
                      type={index === 0 && ownerShown ? "user" : ""}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                      isGroupIcon={entry?.IsGroup}
                      isMultiOwner={isMultiOwner}
                    />
                  </div>
                ))}
          </div>
        </Dropdown.Menu>
        
      </Dropdown>
      {(projects && !isHidden) ? (
        <div className={`member-plus`}>
          <div className={`member-dropdown-toggle-plus`}>
            {
              memberAddDisabled ? 
              <>
              <OverlayTrigger
                placement="bottom-end"
                overlay={
                  <Tooltip>
                      You don't have access to edit projects. Please contact administration for assistance.
                  </Tooltip>
                }
              > 
              <div className={`${position[plusPosition]}`}>
            
                <PlusIcon func={() => setShowPlusPanel(true)} active={showPlusPanel} disabled={memberAddDisabled}></PlusIcon>
                {showPlusPanel ? (
                  <PlusIconPanel
                    userID={UserID}
                    projects={projects}
                    onEdit={onEdit}
                    selectedMembers={[...MembersShown]}
                    close={closePlusPanel}
                  />
                ) : (
                  <></>
                )}
              </div>
              </OverlayTrigger> 
              </>
              :
              <div className={`${position[plusPosition]}`}>
                <OverlayTrigger
                  placement="bottom"
                  show={isMembersTooltipVisible && !showPlusPanel}
                  trigger={['hover','hover']}
                  onToggle={(toggle) => {
                      setIsMembersTooltipVisible(toggle)
                  }}
                  overlay={<Tooltip>Add Member</Tooltip>}>
                      <div>
                          <PlusIcon 
                              className="bg-dark" 
                              func={() => {
                                  setShowPlusPanel(true)
                              }} 
                              active={showPlusPanel}
                              disabled={memberAddDisabled}
                              >
                          </PlusIcon>
                      </div>
                </OverlayTrigger>
                {showPlusPanel ? (
                  <PlusIconPanel
                    userID={UserID}
                    projects={projects}
                    onEdit={onEdit}
                    selectedMembers={[...MembersShown]}
                    close={closePlusPanel}
                  />
                ) : (
                  <></>
                )}
              </div>
            }    
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

ViewMembersPanelNew.propTypes = {
  members: PropTypes.array,
  groups: PropTypes.array,
  taskCreator: PropTypes.object,
  UserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taskType: PropTypes.string,
  projects: PropTypes.object,
  onEdit: PropTypes.func,
  isGroup: PropTypes.bool,
  textChange: PropTypes.bool,
  memberAddDisabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  isMultiOwner: PropTypes.bool,
};

ViewMembersPanelNew.defaultProps = {
  members: [],
  groups: [],
  textChange: false,
  memberAddDisabled: false,
  isHidden: false,
  isMultiOwner: true,
};

export default ViewMembersPanelNew;
